/**
 * Routes: /teams/ and below
 *
 * Will me merged into the router's 'route' array
 */
import TeamsList from '@/views/auth/teams/TeamsList.vue'
import TeamForm from '@/views/auth/teams/TeamForm.vue'

export default [
    {
        path: '/teams',
        name: 'teams',
        component: TeamsList,
        meta: {
            requiresAuth: true,
            title: 'teams',
        },
        children: [
            {
                path: ':id',
                name: 'team_edit',
                component: TeamForm,
                meta: {
                    requiresAuth: true,
                    title: (to: { params: { id: number | string } }) => `Team: ${to.params.id}`,
                },
            },
        ],
    },
]
